export default "__VITE_PUBLIC_ASSET__4e5ecc6e__"